// Marca de orden de bytes UTF-8. Sin ella, Excel abre el archivo asumiendo la
// codificación del sistema y los acentos se ven corruptos ("Garc√≠a" por
// "García"). El backend ya la antepone, pero cuando el CSV viaja como texto
// plano el navegador la interpreta como firma de codificación y la descarta al
// decodificar la respuesta: por eso se vuelve a asegurar acá, que es donde
// realmente se arma el archivo.
const BOM = "﻿";

/**
 * Descarga un contenido de texto como archivo, garantizando que Excel lo abra
 * con la codificación correcta.
 *
 * @param {string} contenido  El texto del archivo (por ejemplo, un CSV)
 * @param {string} nombre     Nombre con el que se guarda
 */
export function descargarCSV(contenido, nombre) {
  const texto = String(contenido ?? "");
  const conMarca = texto.startsWith(BOM) ? texto : BOM + texto;

  const url = window.URL.createObjectURL(
    new Blob([conMarca], { type: "text/csv;charset=utf-8;" })
  );

  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", nombre);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
